var DetailValidationController = (function () {
    function DetailValidationController($scope, env, $filter, $timeout, $q, socket, DTS, DTOptionsBuilder, DTColumnBuilder, _, $compile, $state, $stateParams, topic, moment) {
        var _this = this;
        this.$scope = $scope;
        this.env = env;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$q = $q;
        this.socket = socket;
        this.DTS = DTS;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this._ = _;
        this.$compile = $compile;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.topic = topic;
        this.moment = moment;
        this.showCLGE = false; // Whether the Validation Checklist and GE Decision should show
        this.cmrArray = [];
        this.newSelected = [];
        this.newGoeArray = [];
        this.newCmrArray = [];
        this.goeArray = [];
        this.isCommented = false;
        this.i = 0;
        this.isNewOppty = false;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
        this.OPP_VERSION_5 = 5;
        this.isValidationStartDateDisable = false;
        this.isNonGoeAndAutomatedEligibility = false;
        var vm = this;
        this.socket.forward('queue.validation', this.$scope);
        this.id = $stateParams.id;
        this.activeTab = $state.current.name;
        this.$scope.$on('socket:queue.validation', function (event, data) {
            _this.fillChecklist(event, data);
        });
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            // If the topic is updated, work out if checklist and GE should show
            _this.showCheckListAndGE();
        });
        this.socket.forward('eligibility.getChecksResultsFromValidation', this.$scope);
        this.$scope.$on('socket:eligibility.getChecksResultsFromValidation', function (event, data) {
            if (data.uiFlag) {
                _this.isNewOppty = true;
            }
            _this.cmr = { data: data.incentiveCMRNumber };
        });
        this.socket.forward('validation.manual2ndFindCMRResult', this.$scope);
        this.$scope.$on('socket:validation.manual2ndFindCMRResult', function (event, data) {
            _this.topic.topic.cmr_valid = data.response.cmr_valid;
            _this.topic.topic.goe_valid = data.response.goe_valid;
        });
        this.socket.forward('topic.valid.goecheck', this.$scope);
        this.$scope.$on('socket:topic.valid.goecheck', function (event, data) {
            _this.i += 1;
            if (data.response.ds === 'GOE_DATA') {
                _this.goeArray.push(data.response);
            }
            var goe = _this.topic.topic.goe_data.results ? _this.topic.topic.goe_data.results.length : 0;
            var isGoeEqual = true;
            if (_this.i === goe) {
                if (goe && _this.goeArray) {
                    _this.newGoeArray = _this.getNewGoeCheckArr(_this.goeArray, _this.topic.topic.goe_data.results, 'CMR_NO');
                    var compareValueGoeElig = _this.topic.topic.goe_data.results.map(function (result) {
                        return result.table.map(function (e) {
                            return e.OVERALL_GOE_CD.slice();
                        });
                    });
                    var compareValueGoeValid = _this.newGoeArray.map(function (result) {
                        return result.table.map(function (e) {
                            return e.OVERALL_GOE_CD.slice();
                        });
                    });
                    isGoeEqual = _.isEqual(compareValueGoeElig[0], compareValueGoeValid[0]);
                }
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'performCheck',
                        script: '/detail/eligibility/eligibility',
                        data: {
                            cmrResults: _this.newCmrArray,
                            goeResults: _this.newGoeArray,
                            opp: _this.topic.topic._id.substring(4),
                            isGoeEqual: isGoeEqual
                        },
                        token: _this.env.user.token,
                        bID: _this.topic.topicBrowserID,
                        partial: true
                    }
                });
            }
        });
    }
    DetailValidationController.prototype.getAccountValue = function (accountName) {
        var generics = _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.generics');
        var accountObj = generics.find(function (generic) { return generic.name === accountName; });
        return accountObj ? accountObj.value : '';
    };
    DetailValidationController.prototype.getNewGoeCheckArr = function (newResult, oldResult, type) {
        var _this = this;
        var newGoeArray = [];
        newResult.forEach(function (result, i) {
            var newReport = result.table;
            var reportExcel = oldResult[i].table;
            _this.newSelected = _.clone(result);
            var arr = [];
            _.forEach(newReport, function (newReportLine, j) {
                for (var i_1 = 0; i_1 < reportExcel.length; i_1++) {
                    var selectedTable = reportExcel[i_1];
                    if (newReportLine[type] === selectedTable[type]) {
                        arr.push(newReportLine);
                        console.info(newReportLine);
                    }
                }
            });
            _this.newSelected.table = arr;
            newGoeArray.push(_this.newSelected);
        });
        return newGoeArray;
    };
    DetailValidationController.prototype.changeStartValidDate = function (date) {
        this.isCommented = false;
        var startValidDate = new Date(date).getTime();
        var data = {
            data: {
                'comments.validation': {
                    data: [{
                            comment: "Validation Start Date is changed, reason: " + this.validDateComment,
                            user: this.env.user.email
                        }],
                    push: true
                },
                'startValidDate': {
                    add: true,
                    data: startValidDate
                }
            },
            id: this.topic.topic._id,
            type: ['comments.validation', 'startValidDate']
        };
        this.topic.updateServerTopic('couchUpdate', data, true);
    };
    /**
     * Function to determine if the Validation Checklist and GE Decision components should be
     * rendered on screen
     */
    DetailValidationController.prototype.showCheckListAndGE = function () {
        // The Validation Checklist and GE Decision should only be visible if:
        // 2nd GOE has run
        // Manual Search performed regardless
        // Attachments added regardless
        // TEMPORATY COMMENTED
        // const goe: any = this.topic.getGOEValidStatus(); //Get the GOE results
        // if ((goe.auto > 0 && goe.errors > 0) || // If 2nd GOE and there were errors
        //     goe.manual > 0 || // If manual search done
        //     att) { // If attachments added
        //     this.showCLGE = true;
        // } else {
        //     this.showCLGE = false;
        // }
        var AUTOMATIC_SEARCH_USER_NAME = 'system';
        var att = this.topic.attachmentsFound('fcmr_valid'); //Check for files
        var isManualFindCMRPerformed;
        var isManualFindGOEPerformed;
        if (_.get(this, "topic.topic.cmr_valid.results", []).length) {
            isManualFindCMRPerformed = _.get(this, "topic.topic.cmr_valid.results", [])
                .some(function (cmrSearchResultItem) { return cmrSearchResultItem.user && cmrSearchResultItem.user !== AUTOMATIC_SEARCH_USER_NAME; });
        }
        else {
            isManualFindCMRPerformed = false;
        }
        if (_.get(this, "topic.topic.goe_valid.results", []).length) {
            isManualFindGOEPerformed = _.get(this, "topic.topic.goe_valid.results", [])
                .some(function (goeSearchResultItem) { return goeSearchResultItem.user && goeSearchResultItem.user !== AUTOMATIC_SEARCH_USER_NAME; });
        }
        else {
            isManualFindGOEPerformed = false;
        }
        this.showCLGE = att || isManualFindCMRPerformed || isManualFindGOEPerformed;
    };
    DetailValidationController.prototype.getRestricted = function () {
        return this.isV4OrLess() ? this.getRestrictedV4() : this.getRestrictedV5();
    };
    DetailValidationController.prototype.getRestrictedV4 = function () {
        switch (_.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.opportunity.isRestricted')) {
            case 'RESTNOT':
                return 'Not Restricted';
            case 'RESTOPCL':
                return 'Restricted to opportunity team, client team and incentive review team';
            case 'RESTOPTY':
                return 'Restricted to opportunity team and incentive review team';
            default:
                return '';
        }
    };
    DetailValidationController.prototype.getRevenueV5 = function () {
        if (this.topic.topic.version >= this.OPP_VERSION_5) {
            return _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.opportunityAmount');
        }
        return undefined;
    };
    DetailValidationController.prototype.getOppCurrencyV5 = function () {
        if (this.topic.topic.version >= this.OPP_VERSION_5) {
            return _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.opportunityCurrency');
        }
        return undefined;
    };
    DetailValidationController.prototype.getRestrictedV5 = function () {
        switch (this.topic.topic.isRestr) {
            case 'N':
                return 'Not Restricted';
            case 'Y':
                return 'Restricted';
            default:
                return '';
        }
    };
    DetailValidationController.prototype.$onInit = function () {
        this.isNonGoeAndAutomatedEligibility = _.get(this, 'topic.checksData.isAutoEligibilityGoe', false) && _.get(this, 'topic.topic.goe.picked') === 'No';
        this.showCheckListAndGE(); // Check if checklist and GE need showing
        this.topic.setTempFromTopic();
        this.getNewOppyData();
        this.setValidationDate();
    };
    DetailValidationController.prototype.setValidationDate = function () {
        this.validDate = new Date();
        this.validDate.setTime(this.topic.topic.startValidDate);
        if (!this.env.user.access.bpsoAdmin) {
            this.validDate = this.moment(this.validDate).format('YYYY-MM-DD');
        }
        this.isValidationStartDateDisable = _.get(_.find(this.topic.tabs.list, { name: 'detail.payment' }), 'editable', true);
    };
    DetailValidationController.prototype.getNewOppyData = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getChecksResultsFromValidation',
                script: '/detail/eligibility/eligibility',
                data: {
                    unid: this.topic.topic._id
                },
                token: this.env.user.token
            }
        });
    };
    DetailValidationController.prototype.fillChecklist = function (ev, results) {
        this.topic.loaded.gpp_valid = false;
        this.topic.topic.gpp_valid = results;
    };
    DetailValidationController.prototype.reload = function () {
        this.topic.loaded.gpp_valid = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'validation',
                script: '/detail/validation/validation',
                opp: this.topic.topic.opp,
                unid: this.topic.topic._id,
                token: this.env.user.token
            }
        });
    };
    DetailValidationController.prototype.goeValidation = function () {
        var dataFor2ndGOECheck = {
            opp: this.topic.topic._id
        };
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                bID: this.topic.topicBrowserID,
                data: dataFor2ndGOECheck,
                function: 'run2ndGOECheck',
                partial: true,
                script: '/detail/eligibility/manualFindCMR/index',
                token: this.env.user.token,
                type: 'cmr_valid'
            }
        });
    };
    DetailValidationController.prototype.isV4OrLess = function () {
        var version = this.topic.topic.version;
        return !version || version <= this.OPP_VERSION_4;
    };
    DetailValidationController.$inject = ['$scope', 'env', '$filter',
        '$timeout', '$q', 'socket', 'DTS', 'DTOptionsBuilder', 'DTColumnBuilder', '_', '$compile', '$state', '$stateParams', 'topic', 'moment'
    ];
    return DetailValidationController;
}());
var DetailValidationComponent = (function () {
    function DetailValidationComponent() {
        this.templateUrl = 'detail-validation.html';
        this.controllerAs = 'vm';
        this.controller = DetailValidationController;
    }
    return DetailValidationComponent;
}());
angular
    .module('application')
    .component('detailValidation', new DetailValidationComponent());
var DetailAValidationGppComponent = (function () {
    function DetailAValidationGppComponent() {
        this.templateUrl = 'detail-validation-general.html';
    }
    return DetailAValidationGppComponent;
}());
angular
    .module('application')
    .component('detailValidationGeneral', new DetailAValidationGppComponent());
var DetailAValidationGppcheckComponent = (function () {
    function DetailAValidationGppcheckComponent() {
        this.templateUrl = 'detail-validation-gppcheck.html';
    }
    return DetailAValidationGppcheckComponent;
}());
angular
    .module('application')
    .component('detailValidationGeneralGppcheck', new DetailAValidationGppcheckComponent());

//# sourceMappingURL=detail.validation.component.js.map
